"use client";

import { c as _c } from "react/compiler-runtime";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
function ThemeButton() {
  const $ = _c(7);
  const {
    resolvedTheme: theme,
    setTheme
  } = useTheme();
  let t0;
  if ($[0] !== setTheme || $[1] !== theme) {
    t0 = () => {
      if (theme === "light") {
        setTheme("dark");
      } else {
        setTheme("light");
      }
    };
    $[0] = setTheme;
    $[1] = theme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Sun className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:hidden dark:scale-0 dark:-rotate-90" />;
    t2 = <Moon className="absolute hidden h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:block dark:scale-100 dark:rotate-0" />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0) {
    t3 = <Button aria-label="Toggle theme" variant="outline" size="icon" onClick={t0}>{t1}{t2}</Button>;
    $[5] = t0;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export { ThemeButton };